// The add-note deep link's query string, kept free of '@/' imports so node --test can load it.
// cuelist_layer_id: Notes List A5 (19 Oct 2026).
export default function addNoteParams({ cuelistCueId, cueLabel, cuelistLayerId } = {}) {
    const params = new URLSearchParams({ action: 'new' });
    if (cuelistCueId) {
        params.set('cuelist_cue_id', cuelistCueId);
    }
    if (cueLabel) {
        params.set('cue_label', cueLabel);
    }
    if (cuelistLayerId) {
        params.set('cuelist_layer_id', cuelistLayerId);
    }
    return params;
}


// WEBPACK FOOTER //
// ./src/lib/lxnotes-link-params.js